import type { FC, ReactNode } from 'react';

import Seo from '@/components/Seo';

interface LayoutProps {
  children: ReactNode;
  wide?: boolean;
}

export const AuthLayout: FC<LayoutProps> = (props) => {
  const { children } = props;

  return (
    <div className="tw:flex tw:flex-auto tw:flex-col tw:h-full tw:min-h-[calc(100vh-98px)] tw:py-[49px] tw:px-8 tw:md:px-16">
      <Seo
        title="Sign in to Fuul"
        description="Welcome to Fuul! Sign in to your account or set up a new profile in a few seconds."
        image="/assets/backgrounds/fuul-cover.webp"
      />
      <main className="tw:flex tw:flex-col tw:justify-center tw:flex-1">
        <div className="tw:container tw:mx-auto tw:px-6 tw:max-w-screen-lg">{children}</div>
      </main>
    </div>
  );
};
